module.exports = __webpack_public_path__ + "media/images/landing_page/trees-w-ss-0921a0bcd5999d1537e8fb4839e17ce0.png";